// eslint-disable-next-line import/prefer-default-export
export function useCacheCleaner() {
  const intervalCacheMap = {};

  const startCacheCleaner = (clearCacheAction, {
    intervalDuration = 60 * 60 * 1000,
    customCacheId = 'default',
  } = {}) => {
    intervalCacheMap[customCacheId] = setInterval(() => {
      clearCacheAction();
    }, intervalDuration);
  };

  const stopCacheCleaner = (customCacheId = 'default') => {
    clearInterval(intervalCacheMap[customCacheId]);
  };

  return {
    startCacheCleaner,
    stopCacheCleaner,
  };
}
